import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/gambeat_logo_black_full.png",
  width: "120",
  height: "24"
}, null, -1)
const _hoisted_2 = {
  class: "header__top-wrap flex self-stretch items-center",
  style: {"margin-right":"-24px"}
}
const _hoisted_3 = {
  key: 0,
  class: "q-pr-lg"
}
const _hoisted_4 = { class: "header_border flex self-stretch" }
const _hoisted_5 = {
  key: 1,
  class: "header__lang self-stretch flex items-center header_border"
}
const _hoisted_6 = {
  key: 2,
  class: "header_border flex self-stretch"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HeaderPayment = _resolveComponent("HeaderPayment")!
  const _component_HeaderNotifications = _resolveComponent("HeaderNotifications")!
  const _component_ChangeLang = _resolveComponent("ChangeLang")!
  const _component_HeaderProfile = _resolveComponent("HeaderProfile")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_HeaderMenu = _resolveComponent("HeaderMenu")!
  const _component_q_header = _resolveComponent("q-header")!

  return (_openBlock(), _createBlock(_component_q_header, {
    class: "top-bottom-panel header",
    reveal: _ctx.$q.screen.width >= 1200
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_q_toolbar, { class: "header__top flex justify-between" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/dashboard",
              class: "flex"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              (_ctx.$q.screen.width >= 768)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_HeaderPayment)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_HeaderNotifications)
              ]),
              (_ctx.$q.screen.width >= 1025)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_ChangeLang)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$q.screen.width >= 1025)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_HeaderProfile)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$q.screen.width <= 1199)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 3,
                    "no-caps": "",
                    outline: "",
                    icon: _ctx.heroOutline24Bars3,
                    flat: "",
                    class: "header__hamburger header_border q-px-lg self-stretch",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleMenu')))
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        (_ctx.$q.screen.width >= 1200)
          ? (_openBlock(), _createBlock(_component_HeaderMenu, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["reveal"]))
}